import React, { useEffect, useState } from "react";
import "./OrderHistoryTable.scss";
import {
  OrderDetailsModalData,
  OrderHistoryRow
} from "../../containers/OrderHistoryContainer/types";
import OrderDetailsModalDialog from "../OrderDetailsModalDialog";
import { Denomination } from "../../containers/NewOrderContainer/types";
import WarningIcon from "@material-ui/icons/Warning";
import {
  Backdrop,
  CircularProgress,
  createStyles,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Theme,
  Tooltip
} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import OrderResultsModal from "../OrderResultsModal";
import TablePagination from "@material-ui/core/TablePagination";
import StorageIcon from "@material-ui/icons/Storage";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import updateSelectedItems from "./updateSelectedItems";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import DateInputField from "../DateInputField";
import moment from "moment";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    },
    searchField: {
      marginBottom: "5px"
    },
    tableColumnButton: {
      width: "100%",
      height: "100%"
    },
    processButton: {
      marginBottom: "5px",
      marginLeft: "0 !important"
    },
    dropDown: {
      fontSize: "0.9rem",
      margin: "5px",
      minWidth: "5vw"
    },
    dropDownField: {
      fontSize: "0.9rem",
      width: "100%"
    },
    inputField: {
      fontSize: "0.9rem",
      margin: "5px",
      minWidth: "5vw"
    },
    datePickerMargin: {
      margin: "5px"
    }
  })
);

const OrderHistoryTable = (props: any) => {
  const sortBy = props.sortCriteria && props.sortCriteria.sortBy;
  const sortDirection = props.sortCriteria && props.sortCriteria.sortDirection;

  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [page, setPage] = React.useState(
    props.paginationInfo ? props.paginationInfo.currentPage || 0 : 0
  );
  const [orderHistory, setOrderHistory] = useState<any>([]);
  const [openActionDialog, setOpenActionDialog] = useState<boolean>(false);
  const [
    openProcessConfirmationDialog,
    setOpenProcessConfirmationDialog
  ] = useState<boolean>(false);
  const [openOrderResultsModal, setOpenOrderResultsModal] = useState<boolean>(
    false
  );
  const [modalData, setModalData] = useState<OrderDetailsModalData>(
    {} as OrderDetailsModalData
  );
  const [sortCriteria, setSortCriteria] = useState<any>({
    sortBy: sortBy,
    sortDirection: sortDirection
  });
  const [sortClickCount, setSortClickCount] = React.useState(0);
  const [selectedItems, setSelectedItems] = React.useState<any[]>([]);
  const [lastSelected, setLastSelected] = React.useState<any>();
  const [filterType, setFilterType] = React.useState<string>(
    (props.filter && props.filter.type) || ""
  );
  const [filterBranchNameInput, setFilterBranchNameInput] = React.useState<
    string
  >((props.filter && props.filter.branchName) || "");
  const [filterBranchName, setFilterBranchName] = React.useState<string>(
    filterBranchNameInput
  );
  const [filterCurrency, setFilterCurrency] = React.useState<number>(
    (props.filter && props.filter.currency) || -1
  );
  const [filterDatePlacedTo, setFilterDatePlacedTo] = React.useState<string>(
    (props.filter &&
      props.filter.datePlacedTo &&
      moment(props.filter.datePlacedTo, "YYYY-MM-DD").format("DD/MM/YYYY")) ||
      ""
  );
  const [filterDatePlacedFrom, setFilterDatePlacedFrom] = React.useState<
    string
  >(
    (props.filter &&
      props.filter.datePlacedFrom &&
      moment(props.filter.datePlacedFrom, "YYYY-MM-DD").format("DD/MM/YYYY")) ||
      ""
  );
  const [filterDateRequiredTo, setFilterDateRequiredTo] = React.useState<
    string
  >(
    (props.filter &&
      props.filter.dateRequiredTo &&
      moment(props.filter.dateRequiredTo, "YYYY-MM-DD").format("DD/MM/YYYY")) ||
      ""
  );
  const [filterDateRequiredFrom, setFilterDateRequiredFrom] = React.useState<
    string
  >(
    (props.filter &&
      props.filter.dateRequiredFrom &&
      moment(props.filter.dateRequiredFrom, "YYYY-MM-DD").format(
        "DD/MM/YYYY"
      )) ||
      ""
  );
  const [filterStatus, setFilterStatus] = React.useState<string[]>(
    props.filter && props.filter.status
      ? ("" + props.filter.status).split(",")
      : []
  );

  useEffect(() => {
    setSortCriteria({ sortBy, sortDirection });
  }, [sortBy, sortDirection]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (props.onChangePageNumber) {
      props.onChangePageNumber(newPage + 1);
    }
    setPage(newPage);
    setLastSelected(-1);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (props.onChangePageNumber) {
      props.onChangePageNumber(1);
    }
    props.onChangePageSize(parseInt(event.target.value, 10));
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setLastSelected(-1);
  };

  const handleFilterChange = () => {
    if (props.onChangePageNumber) {
      props.onChangePageNumber(1);
    }
    setPage(0);
    setLastSelected(-1);
  };

  const classes = useStyles();

  useEffect(() => {
    if (
      orderHistory &&
      orderHistory.some(
        (item: any) => item.branch.name === filterBranchNameInput
      )
    ) {
      setFilterBranchName(filterBranchNameInput);
    } else if (filterBranchNameInput.length === 0) {
      setFilterBranchName("");
    }
  }, [filterBranchNameInput]);

  useEffect(() => {
    props.onFilter &&
      props.onFilter({
        type: filterType,
        branchName: filterBranchName,
        status: filterStatus,
        currency: filterCurrency,
        dateRequiredFrom: !filterDateRequiredFrom
          ? ""
          : moment(filterDateRequiredFrom, "DD/MM/YYYY").format("YYYY-MM-DD"),
        dateRequiredTo: !filterDateRequiredTo
          ? ""
          : moment(filterDateRequiredTo, "DD/MM/YYYY").format("YYYY-MM-DD"),
        datePlacedFrom: !filterDatePlacedFrom
          ? ""
          : moment(filterDatePlacedFrom, "DD/MM/YYYY").format("YYYY-MM-DD"),
        datePlacedTo: !filterDatePlacedTo
          ? ""
          : moment(filterDatePlacedTo, "DD/MM/YYYY").format("YYYY-MM-DD")
      });
  }, [
    filterType,
    filterBranchName,
    filterStatus,
    filterCurrency,
    filterDateRequiredTo,
    filterDateRequiredFrom,
    filterDatePlacedTo,
    filterDatePlacedFrom
  ]);

  useEffect(() => {
    setOrderHistory(props.orderHistory);
  }, [props.orderHistory]);

  useEffect(() => {
    setSelectedItems([]);
  }, [props.processedCount]);

  function buildDenominationsString(denominations: Denomination[]) {
    let string = "";
    if (denominations) {
      denominations.forEach((denom: Denomination) => {
        string = string
          .concat(denom.orderValue.toString())
          .concat(" in ")
          .concat(
            `${denom.unitValue.toLocaleString(navigator.language, {
              minimumFractionDigits: 0
            })}s`
          )
          .concat(", ");
      });
      return string.slice(0, -2);
    } else {
      return "";
    }
  }

  useEffect(() => {
    if (
      typeof props.priceSummary !== "undefined" &&
      typeof props.selectedOrder !== "undefined" &&
      typeof props.selectedOrder.currency !== "undefined" &&
      props.selectedOrder !== null
    ) {
      setModalData({
        id: props.selectedOrder.id,
        type: props.selectedOrderType,
        version: props.selectedOrder.version,
        dateOrdered: props.selectedOrder.dateOrdered,
        dateRequired: props.selectedOrder.dateRequired,
        currency: `${props.selectedOrder.currency.region} - ${props.selectedOrder.currency.name}`,
        currencySymbol: props.selectedOrder.currency.symbol,
        currencyCode: props.selectedOrder.currency.code,
        currencyAmount: props.selectedOrder.currencyAmount,
        travellerName: props.selectedOrder.travellerName,
        denominations: buildDenominationsString(
          props.selectedOrder.denominations
        ),
        status: props.selectedOrder.status,
        branch: props.selectedOrder.branch,
        raisedBy: props.selectedOrder.raisedBy,
        authorisedBy: props.selectedOrder.authorisedBy,
        processedBy: props.selectedOrder.processedBy,
        exchangeRate: props.selectedOrder.price
          ? props.selectedOrder.price.rate
          : props.priceSummary.rate,
        price: props.selectedOrder.price
          ? props.selectedOrder.price.price
          : props.priceSummary.price,
        fees: props.selectedOrder.price
          ? props.selectedOrder.price.fees
          : props.priceSummary.fees,
        total: props.selectedOrder.price
          ? props.selectedOrder.price.total
          : props.priceSummary.total,
        auditHistory: props.selectedOrder.auditHistory,
        number: props.selectedOrder.number,
        settlementSource: props.selectedOrder.settlementSource
      } as OrderDetailsModalData);
    }
  }, [props.priceSummary, props.selectedOrder]);

  function handleOpenButtonClick(item: OrderHistoryRow) {
    props.onOrderSelect && props.onOrderSelect(item.id, item.type);
    setOpenActionDialog(true);
  }

  function handleSorting(headerName: number) {
    if (sortCriteria.sortBy === headerName) {
      if (sortClickCount % 2 === 0) {
        setSortCriteria({ sortBy: headerName, sortDirection: 1 });
        props.onSort({ sortBy: headerName, sortDirection: 1 });
      } else {
        setSortCriteria({ sortBy: headerName, sortDirection: 0 });
        props.onSort({ sortBy: headerName, sortDirection: 0 });
      }
      setSortClickCount(n => n + 1);
    } else if (sortCriteria.sortBy !== headerName) {
      setSortCriteria({ sortBy: headerName, sortDirection: 0 });
      props.onSort({ sortBy: headerName, sortDirection: 0 });
      setSortClickCount(0);
    }
  }

  const handleStatusFilter = (event: React.ChangeEvent<{ value: unknown }>) => {
    handleFilterChange();
    setFilterStatus(event.target.value as string[]);
  };

  const selectedItemsReadyForProcessing = selectedItems.filter(item => {
    return (
      (item.type === "Order" && item.status === "Ordered") ||
      (item.type !== "Order" && item.status === "Awaiting Processing")
    );
  });
  const selectedItemsThatCanBeProcessed =
    selectedItemsReadyForProcessing.length;
  const selectedItemsThatCannotBeProcessed =
    selectedItems.length - selectedItemsThatCanBeProcessed;

  return (
    <>
      {" "}
      {!props.isLoadingOrders ? (
        <div className="OrderHistoryTable--mainContainer">
          <div className="OrderHistoryTable--toolbar-container">
            <Button
              startIcon={<ArrowForwardIcon />}
              variant="contained"
              color="primary"
              className={`OrderHistoryTable-processButton ${classes.processButton}`}
              onClick={evt => {
                setOpenProcessConfirmationDialog(true);
              }}
              disabled={selectedItems.length === 0}
            >
              Process All
            </Button>
            <div className="OrderHistoryTable--pagination-container">
              <TablePagination
                component="div"
                count={props.paginationInfo.totalCount || 0}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100, 200]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </div>
          </div>
          <table className="OrderHistoryTable--container">
            <thead className="OrderHistoryTable--headPanel">
              <tr className="OrderHistoryTable--headPanelRow">
                <th>
                  <Checkbox
                    className="OrderHistoryTable-selectAll"
                    onChange={evt => {
                      if (orderHistory) {
                        let selected = selectedItems;
                        for (let i = 0; i < orderHistory.length; i++) {
                          const item = orderHistory[i];
                          selected = updateSelectedItems(
                            selected,
                            item,
                            evt.target.checked
                          );
                        }
                        setSelectedItems(selected);
                      }
                    }}
                  />
                </th>
                <th
                  className="OrderHistoryTable--typeTableHeader"
                  onClick={() => handleSorting(0)}
                >
                  <div className="OrderHistoryTable--tableHeader">
                    <div>Type</div>
                    {sortCriteria.sortBy === 0 &&
                    sortCriteria.sortDirection === 0 ? (
                      <ArrowUpwardIcon className="OrderHistoryTable--ascendingIcon" />
                    ) : sortCriteria.sortBy === 0 &&
                      sortCriteria.sortDirection === 1 ? (
                      <ArrowDownwardIcon className="OrderHistoryTable--descendingIcon" />
                    ) : (
                      <ImportExportIcon className="OrderHistoryTable--unsortedIcon" />
                    )}
                  </div>
                </th>
                <th
                  className="OrderHistoryTable--branchTableHeader"
                  onClick={() => handleSorting(1)}
                >
                  <div className="OrderHistoryTable--tableHeader">
                    <div>Branch Name</div>
                    {sortCriteria.sortBy === 1 &&
                    sortCriteria.sortDirection === 0 ? (
                      <ArrowUpwardIcon className="OrderHistoryTable--ascendingIcon" />
                    ) : sortCriteria.sortBy === 1 &&
                      sortCriteria.sortDirection === 1 ? (
                      <ArrowDownwardIcon className="OrderHistoryTable--descendingIcon" />
                    ) : (
                      <ImportExportIcon className="OrderHistoryTable--unsortedIcon" />
                    )}
                  </div>
                </th>
                <th
                  className="OrderHistoryTable--currencyTableHeader"
                  onClick={() => handleSorting(2)}
                >
                  <div className="OrderHistoryTable--tableHeader">
                    <div>Currency</div>
                    {sortCriteria.sortBy === 2 &&
                    sortCriteria.sortDirection === 0 ? (
                      <ArrowUpwardIcon className="OrderHistoryTable--ascendingIcon" />
                    ) : sortCriteria.sortBy === 2 &&
                      sortCriteria.sortDirection === 1 ? (
                      <ArrowDownwardIcon className="OrderHistoryTable--descendingIcon" />
                    ) : (
                      <ImportExportIcon className="OrderHistoryTable--unsortedIcon" />
                    )}
                  </div>
                </th>
                <th
                  className="OrderHistoryTable--currencyAmountTableHeader"
                  onClick={() => handleSorting(3)}
                >
                  <div className="OrderHistoryTable--tableHeader">
                    <div>Currency Amount</div>
                    {sortCriteria.sortBy === 3 &&
                    sortCriteria.sortDirection === 0 ? (
                      <ArrowUpwardIcon className="OrderHistoryTable--ascendingIcon" />
                    ) : sortCriteria.sortBy === 3 &&
                      sortCriteria.sortDirection === 1 ? (
                      <ArrowDownwardIcon className="OrderHistoryTable--descendingIcon" />
                    ) : (
                      <ImportExportIcon className="OrderHistoryTable--unsortedIcon" />
                    )}
                  </div>
                </th>
                <th
                  className="OrderHistoryTable--commentsTableHeader"
                  onClick={() => handleSorting(4)}
                >
                  <div className="OrderHistoryTable--tableHeader">
                    <div>Comments</div>
                    {sortCriteria.sortBy === 4 &&
                    sortCriteria.sortDirection === 0 ? (
                      <ArrowUpwardIcon className="OrderHistoryTable--ascendingIcon" />
                    ) : sortCriteria.sortBy === 4 &&
                      sortCriteria.sortDirection === 1 ? (
                      <ArrowDownwardIcon className="OrderHistoryTable--descendingIcon" />
                    ) : (
                      <ImportExportIcon className="OrderHistoryTable--unsortedIcon" />
                    )}
                  </div>
                </th>
                <th
                  className="OrderHistoryTable--dateOrderedTableHeader"
                  onClick={() => handleSorting(5)}
                >
                  <div className="OrderHistoryTable--tableHeader">
                    <div>Date Placed</div>
                    {sortCriteria.sortBy === 5 &&
                    sortCriteria.sortDirection === 0 ? (
                      <ArrowUpwardIcon className="OrderHistoryTable--ascendingIcon" />
                    ) : sortCriteria.sortBy === 5 &&
                      sortCriteria.sortDirection === 1 ? (
                      <ArrowDownwardIcon className="OrderHistoryTable--descendingIcon" />
                    ) : (
                      <ImportExportIcon className="OrderHistoryTable--unsortedIcon" />
                    )}
                  </div>
                </th>
                <th
                  className="OrderHistoryTable--dateRequiredTableHeader"
                  onClick={() => handleSorting(6)}
                >
                  <div className="OrderHistoryTable--tableHeader">
                    <div>Date Required</div>
                    {sortCriteria.sortBy === 6 &&
                    sortCriteria.sortDirection === 0 ? (
                      <ArrowUpwardIcon className="OrderHistoryTable--ascendingIcon" />
                    ) : sortCriteria.sortBy === 6 &&
                      sortCriteria.sortDirection === 1 ? (
                      <ArrowDownwardIcon className="OrderHistoryTable--descendingIcon" />
                    ) : (
                      <ImportExportIcon className="OrderHistoryTable--unsortedIcon" />
                    )}
                  </div>
                </th>
                <th
                  className="OrderHistoryTable--statusTableHeader"
                  onClick={() => handleSorting(7)}
                >
                  <div className="OrderHistoryTable--tableHeader">
                    <div>Current Status</div>
                    {sortCriteria.sortBy === 7 &&
                    sortCriteria.sortDirection === 0 ? (
                      <ArrowUpwardIcon className="OrderHistoryTable--ascendingIcon" />
                    ) : sortCriteria.sortBy === 7 &&
                      sortCriteria.sortDirection === 1 ? (
                      <ArrowDownwardIcon className="OrderHistoryTable--descendingIcon" />
                    ) : (
                      <ImportExportIcon className="OrderHistoryTable--unsortedIcon" />
                    )}
                  </div>
                </th>
                <th></th>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div className="OrderHistoryFilter-type">
                    <FormControl>
                      <Select
                        value={filterType}
                        className={classes.dropDown}
                        variant="outlined"
                        displayEmpty
                        onChange={(evt: any) => {
                          handleFilterChange();
                          setFilterType(evt.target.value);
                        }}
                      >
                        <MenuItem className={classes.dropDownField} value={""}>
                          All
                        </MenuItem>
                        <MenuItem
                          className={classes.dropDownField}
                          value={"Order"}
                        >
                          Order
                        </MenuItem>
                        <MenuItem
                          className={classes.dropDownField}
                          value={"Return"}
                        >
                          Return
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </td>
                <td>
                  <div className="OrderHistoryFilter-branchName">
                    <FormControl>
                      <Select
                        value={filterBranchName}
                        className={classes.dropDown}
                        variant="outlined"
                        displayEmpty
                        onChange={(evt: any) => {
                          handleFilterChange();
                          setFilterBranchName(evt.target.value);
                        }}
                      >
                        <MenuItem className={classes.dropDownField} value="">
                          All
                        </MenuItem>
                        {props.branches &&
                          props.branches.map((item: any, itemIndex: number) => (
                            <MenuItem
                              className={classes.dropDownField}
                              value={item.name}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                </td>
                <td>
                  <div className="OrderHistoryFilter-currency">
                    <FormControl>
                      <Select
                        value={filterCurrency}
                        className={classes.dropDown}
                        variant="outlined"
                        displayEmpty
                        onChange={(evt: any) => {
                          handleFilterChange();
                          setFilterCurrency(evt.target.value);
                        }}
                      >
                        <MenuItem className={classes.dropDownField} value={-1}>
                          All
                        </MenuItem>
                        {props.currencies &&
                          props.currencies.map(
                            (item: any, itemIndex: number) => (
                              <MenuItem
                                className={classes.dropDownField}
                                value={item.id}
                              >
                                {`${item.region} - ${item.name}`}
                              </MenuItem>
                            )
                          )}
                      </Select>
                    </FormControl>
                  </div>
                </td>
                <td></td>
                <td></td>
                <td>
                  <div className="OrderHistoryTable--datePlacedFilterContainer">
                    <DateInputField
                      className={`${classes.datePickerMargin} OrderHistoryFilter-datePlacedFrom`}
                      value={filterDatePlacedFrom}
                      onChange={(date: any) => {
                        handleFilterChange();
                        setFilterDatePlacedFrom(date);
                      }}
                    />
                    <DateInputField
                      className={`${classes.datePickerMargin} OrderHistoryFilter-datePlacedTo`}
                      value={filterDatePlacedTo}
                      onChange={(date: any) => {
                        handleFilterChange();
                        setFilterDatePlacedTo(date);
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="OrderHistoryTable--dateRequiredFilterContainer">
                    <DateInputField
                      className={`${classes.datePickerMargin} OrderHistoryFilter-dateRequiredFrom`}
                      value={filterDateRequiredFrom}
                      onChange={(date: any) => {
                        handleFilterChange();
                        setFilterDateRequiredFrom(date);
                      }}
                    />
                    <DateInputField
                      className={`${classes.datePickerMargin} OrderHistoryFilter-dateRequiredTo`}
                      value={filterDateRequiredTo}
                      onChange={(date: any) => {
                        handleFilterChange();
                        setFilterDateRequiredTo(date);
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="OrderHistoryFilter-status">
                    <FormControl>
                      <Select
                        className={classes.dropDown}
                        variant="outlined"
                        displayEmpty
                        multiple
                        value={filterStatus}
                        onChange={handleStatusFilter}
                      >
                        <MenuItem className={classes.dropDownField} value={""}>
                          All
                        </MenuItem>
                        <MenuItem
                          className={classes.dropDownField}
                          value={"Ordered"}
                        >
                          Ordered
                        </MenuItem>
                        <MenuItem
                          className={classes.dropDownField}
                          value={"Processed"}
                        >
                          Processed
                        </MenuItem>
                        <MenuItem
                          className={classes.dropDownField}
                          value={"UploadingToIntrafin"}
                        >
                          Uploading To Intrafin
                        </MenuItem>
                        <MenuItem
                          className={classes.dropDownField}
                          value={"Dispatched"}
                        >
                          Dispatched
                        </MenuItem>
                        <MenuItem
                          className={classes.dropDownField}
                          value={"RequiresAuthorisation"}
                        >
                          Requires Authorisation
                        </MenuItem>
                        <MenuItem
                          className={classes.dropDownField}
                          value={"Cancelled"}
                        >
                          Cancelled
                        </MenuItem>
                        <MenuItem
                          className={classes.dropDownField}
                          value={"AwaitingProcessing"}
                        >
                          Awaiting Processing
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {orderHistory &&
                orderHistory.map((item: OrderHistoryRow, itemIndex: number) => (
                  <tr
                    className="OrderHistoryTable--row"
                    key={`OrderHistoryRow-${item.id}`}
                    onClick={() => {
                      handleOpenButtonClick(item);
                    }}
                  >
                    <td className="OrderHistoryItem-include">
                      <Checkbox
                        onClick={(evt: any) => {
                          evt.stopPropagation();
                          if (evt.shiftKey && lastSelected >= 0) {
                            const startIndex =
                              lastSelected < itemIndex
                                ? lastSelected
                                : itemIndex;
                            const endIndex =
                              lastSelected < itemIndex
                                ? itemIndex
                                : lastSelected;
                            let selected = selectedItems;
                            for (let i = startIndex; i <= endIndex; i++) {
                              const anItem = orderHistory[i];
                              selected = updateSelectedItems(
                                selected,
                                anItem,
                                true
                              );
                            }
                            setSelectedItems(selected);
                          } else {
                            setSelectedItems(items =>
                              updateSelectedItems(
                                items,
                                item,
                                evt.target.checked
                              )
                            );
                          }
                          if (evt.target.checked) {
                            setLastSelected(itemIndex);
                          } else {
                            setLastSelected(-1);
                          }
                        }}
                        checked={
                          selectedItems.findIndex(i => i.id === item.id) !== -1
                        }
                      />
                    </td>
                    <td className="OrderHistoryItem-type">{item.type}</td>
                    <td className="OrderHistoryItem-branchName">
                      {item.branch && item.branch.name}
                    </td>
                    <td className="OrderHistoryItem-currency">{`${item.currencyRegion} - ${item.currencyName}`}</td>
                    <td className="OrderHistoryItem-currencyAmount">
                      {item.currencyAmount.toLocaleString(navigator.language, {
                        minimumFractionDigits: 2
                      })}
                    </td>
                    <td className="OrderHistoryItem-comments">
                      {item.comments}
                    </td>
                    <td className="OrderHistoryItem-dateOrdered">
                      {item.dateOrdered}
                    </td>
                    <td className="OrderHistoryItem-dateRequired">
                      {item.dateRequired}
                    </td>
                    <td className="OrderHistoryItem-currentStatus">
                      {item.status}
                    </td>
                    <td>
                      {item.status === "Ordered" ? (
                        <Tooltip title="Indicative price only">
                          <WarningIcon className="OrderHistoryItem-indicativeWarning"></WarningIcon>
                        </Tooltip>
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                ))}
              <OrderDetailsModalDialog
                open={openActionDialog}
                data={modalData}
                isLoadingOrder={props.isLoadingOrder}
                onProcess={() => props.onProcess()}
                onAuthorise={props.onAuthorise}
                onCancelOrder={props.onCancelOrder}
                onClose={() => setOpenActionDialog(false)}
                openOrderResultsModal={props.openOrderResultsModal}
                onOpenOrderResultsModal={() => setOpenOrderResultsModal(true)}
                permissions={props.permissions}
              />
              <OrderResultsModal
                open={openOrderResultsModal}
                onClose={() => setOpenOrderResultsModal(false)}
                items={props.authorisedOrderResult}
                onReferredOrders={(x: any) => props.onReferredOrders(x)}
                returns={props.selectedOrderType === "Return"}
              />
            </tbody>
          </table>
          {orderHistory && orderHistory.length === 0 ? (
            <div className="OrderHistoryTable--noDataContainer">
              <StorageIcon className="OrderHistoryTable--noDataIcon" />
              <p className="OrderHistoryTable--noDataText">
                There are currently no orders to display.
              </p>
            </div>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <div>
          <Backdrop className={classes.backdrop} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      )}
      <Dialog
        className="OrderHistoryTable-processConfirmation"
        open={openProcessConfirmationDialog}
        onClose={() => {
          setOpenProcessConfirmationDialog(false);
        }}
      >
        <DialogTitle>Process items</DialogTitle>
        <DialogContent>
          <div className="ProcessConfirmationDialog-message">
            {selectedItemsThatCanBeProcessed === 0
              ? "None of the items you have chosen can currently be processed."
              : selectedItemsThatCannotBeProcessed > 0
              ? `${selectedItemsThatCannotBeProcessed} of the items you chose cannot currently be processed. Do you want to process other ${selectedItemsThatCanBeProcessed}?`
              : selectedItemsThatCanBeProcessed === 1
              ? `Do you want to process this item?`
              : `Do you want to process these ${selectedItemsThatCanBeProcessed} items?`}
          </div>
        </DialogContent>
        <DialogActions>
          {selectedItemsThatCanBeProcessed > 0 && (
            <Button
              className="ProcessConfirmationDialog-cancelButton"
              onClick={() => {
                setOpenProcessConfirmationDialog(false);
              }}
            >
              Cancel
            </Button>
          )}
          <Button
            className="ProcessConfirmationDialog-okButton"
            color="primary"
            onClick={() => {
              props.onProcessAll(selectedItemsReadyForProcessing);
              setOpenProcessConfirmationDialog(false);
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OrderHistoryTable;
